import * as React from 'react';

import { get as userGet } from 'js/lib/user';

import type { EnterpriseLoggedInPageHeader_EnterpriseProgramFragment as Program } from 'bundles/composable-page-header-enterprise/queries/__generated__/EnterpriseLoggedInMyPageHeaderQuery';
import MobileEnterpriseSearchBar, {
  UnifiedMobileEnterpriseSearchBar,
} from 'bundles/enterprise-learner-search/components/search/MobileEnterpriseSearchBar';
import { useEnterpriseProductFeatures } from 'bundles/unified-common/contexts/EnterpriseProductFeaturesContext';

type Props = {
  currentProgram?: Partial<Program> | null;
};

export function EnterpriseMobileSearchBarLegacyGridItem(props: Props) {
  const { currentProgram } = props;
  const enterpriseProductFeatures = useEnterpriseProductFeatures();
  const userId = userGet()?.id;

  const enableSkillsInSearchAndBrowse = enterpriseProductFeatures?.enableSkillsInSearchAndBrowse;
  const shouldShowShortFormContent = enterpriseProductFeatures?.allowShortFormContentBasedOnAudience;

  const thirdPartyOrg = currentProgram?.naptimeThirdPartyOrganization;

  const programSlug = currentProgram?.slug;
  const programName = currentProgram?.name;
  const programId = currentProgram?.id;

  if (userId && programName && programSlug && programId && thirdPartyOrg) {
    return (
      <UnifiedMobileEnterpriseSearchBar
        programSlug={programSlug}
        programName={programName}
        thirdPartyOrgSlug={thirdPartyOrg.slug}
        thirdPartyOrganizationId={thirdPartyOrg.id}
        userId={userId}
        programId={programId}
        enableSkillsInSearchAndBrowse={enableSkillsInSearchAndBrowse}
        shouldShowShortFormContent={shouldShowShortFormContent}
      />
    );
  } else if (programId) {
    return (
      <MobileEnterpriseSearchBar
        programIds={[programId]}
        enableSkillsInSearchAndBrowse={!!enableSkillsInSearchAndBrowse}
        programName={programName}
        shouldShowShortFormContent={shouldShowShortFormContent}
      />
    );
  }
  return null;
}

export default EnterpriseMobileSearchBarLegacyGridItem;
